import { viewTitleFillColor } from "~/utils/constants";
import { baseBorderColor, colorNameMap, edstFontName, eramFontDimensionMap, EramFontName, ViewItem } from "@poscon/shared-frontend";
import { closeAselMenu, closeView } from "~redux/slices/edstSlice";
import React from "react";
import type { EdstView } from "types/edstView";
import type { ColorSource, FederatedEventHandler } from "pixi.js";
import { useRootDispatch } from "~redux/hooks";
import { isAselMenu } from "types/edstView";

type MenuTitleBarProps = {
  title: string;
  view: EdstView;
  width: number;
  onTitleMouseDown: FederatedEventHandler;
  tint?: ColorSource;
  fill?: ColorSource;
  withX?: boolean;
  fontName?: EramFontName;
  closeMenu?: () => void;
};
export const MenuTitleBar = ({ title, width, onTitleMouseDown, closeMenu, view, fontName = edstFontName, fill = viewTitleFillColor, withX = true, tint = colorNameMap.black }: MenuTitleBarProps) => {
  const dispatch = useRootDispatch();
  const { width: fontWidth, height: fontHeight } = eramFontDimensionMap[fontName];
  const xX = width - fontHeight;
  const labelWidth = width - (withX ? fontHeight : 0);

  return (
    <>
      <ViewItem
        text={title}
        width={labelWidth}
        onmousedown={onTitleMouseDown}
        fillColor={fill}
        fontName={fontName}
        fill
        tint={tint}
        borderColor={baseBorderColor}
      />
      {withX && <ViewItem
        text="X"
        x={xX}
        width={fontHeight}
        fontName={fontName}
        onmousedown={() => {
          if (isAselMenu(view)) {
            dispatch(closeAselMenu());
          }
          closeMenu?.();
          dispatch(closeView(view));
        }}
        fillColor={fill}
        fill
        tint={tint}
        borderColor={baseBorderColor}
      />}
    </>
  );
};
